import { createRef, useEffect } from "react";

import moment from "moment";
import { useSelector } from "react-redux";

import { timeSlots } from "../../utils/utils";
import CalendarDaysOfWeek from "./CalendarDaysOfWeek";
import WeekCalendarSchedules from "./WeekCalendarSchedules";
import WeekCalendarSchedulesManagement from "./WeekCalendarSchedulesManagement";

function MonthCalendar({ calendarObj }) {
  const weekBoxRef = createRef();
  const { user } = useSelector((state) => state.userReducer);
  const { selectedStart } = useSelector((state) => state.calendarReducer);

  const { schedules, onSchedulesClick, onScheduleClick } = calendarObj;

  const startDate = moment(selectedStart).clone().startOf("week");
  const rows = [];
  let days = [];
  let day = startDate;
  for (const time in timeSlots) {
    for (let i = 0; i < 7; i++) {
      const daySchedules = schedules.filter((item) => item.scheduledDate === day.format("YYYY-MM-DD"));
      const timeSchedules = daySchedules
        .filter((item) => item.scheduledStartTime.slice(0, 5) === timeSlots[time])
        .sort((a, b) => {
          if (a.status > b.status) return -1;
          if (a.status < b.status) return 1;
          return 0;
        });
      days.push(
        <div key={timeSlots[time] + i} className={`weekTime`}>
          {user?.role === "student" || user?.role === "teacher" ? (
            <WeekCalendarSchedules timeSchedules={timeSchedules} onScheduleClick={onScheduleClick} />
          ) : (
            <WeekCalendarSchedulesManagement
              timeSchedules={timeSchedules}
              onSchedulesClick={onSchedulesClick}
              onScheduleClick={onScheduleClick}
            />
          )}
        </div>,
      );
      day = day.clone().add(1, "day");
    }
    day = startDate;
    rows.push(
      <div className="weekTimeBox" key={timeSlots[time]}>
        {timeSlots[time].slice(3, 4) !== "3" && (
          <p className="weekCalendarTime">{moment(`2019-05-02 ${timeSlots[time]}`).format("h a")}</p>
        )}
        {days}
      </div>,
    );
    days = [];
  }

  useEffect(() => {
    weekBoxRef.current.scrollTop = 594;
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <CalendarDaysOfWeek calendarObj={calendarObj} />
      <div className="weekBox" ref={weekBoxRef}>
        {rows}
      </div>
    </>
  );
}

export default MonthCalendar;
